module.exports = __webpack_public_path__ + "media/images/pdf/footer-57c4c502daa013d1a984117d92caf263.png";